import { useEffect, useState } from "react";

const MOBILE_PLATFORMS = new Set(["android", "ios", "android_x"]);

function isMobilePlatform(): boolean {
  if (document.documentElement.classList.contains("platform-mobile")) return true;
  if (document.documentElement.classList.contains("platform-desktop")) return false;
  const platform = window.Telegram?.WebApp?.platform;
  if (platform && MOBILE_PLATFORMS.has(platform)) return true;
  return window.matchMedia("(max-width: 900px) and (pointer: coarse)").matches;
}

function isLandscapeViewport(): boolean {
  if (typeof window === "undefined") return false;
  return window.innerWidth > window.innerHeight;
}

/** Blocks gameplay in landscape on phones/tablets — portrait only. */
export function OrientationGuard() {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const update = () => {
      setBlocked(isMobilePlatform() && isLandscapeViewport());
    };

    update();
    const media = window.matchMedia("(orientation: landscape)");
    media.addEventListener("change", update);
    window.addEventListener("resize", update);
    return () => {
      media.removeEventListener("change", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  if (!blocked) return null;

  return (
    <div className="orientation-lock fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4 bg-kingdom-dark px-8 text-center">
      <div className="text-6xl animate-pulse">📱</div>
      <h2 className="text-xl font-bold font-game text-gold-400">Rotate your device</h2>
      <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
        Meltown Kingdoms works in portrait orientation only.
      </p>
    </div>
  );
}
